import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FileText, Clock } from "lucide-react";
import api from "../api";
import { useApp } from "../context/AppContext";
import { Seo } from "../components/Seo";
import { Button } from "../components/ui/button";

export default function Services() {
  const { t, lang } = useApp();
  const navigate = useNavigate();
  const [services, setServices] = useState([]);

  useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch(() => {}); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 py-10" data-testid="services-page">
      <Seo title="Property Documents Gujarat" description="Request 7/12, 8-A, Ferfar, Property Card, Index-2, Certified Copy, EC and more Gujarat property documents online." />
      <h1 className="font-display font-bold text-3xl md:text-4xl">{t("services")}</h1>
      <p className="text-muted-foreground mt-2 mb-8 max-w-2xl">{t("our_services_sub")}</p>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {services.map((s) => (
          <div key={s.id} className="bg-white border border-border rounded-xl p-6 card-hover" data-testid={`service-detail-${s.slug}`}>
            <div className="flex items-start justify-between">
              <span className="w-11 h-11 rounded-lg bg-primary/10 text-primary flex items-center justify-center"><FileText size={22} /></span>
              <span className="text-[10px] font-semibold uppercase px-2 py-1 rounded bg-muted text-muted-foreground">{t("assistance")}</span>
            </div>
            <h2 className="font-display font-semibold text-lg mt-3">{lang === "gu" && s.name_gu ? s.name_gu : s.name_en}</h2>
            <p className="text-sm text-foreground/60 font-medium">{lang === "gu" ? s.name_en : s.name_gu}</p>
            <p className="text-sm text-muted-foreground mt-2">{lang === "gu" && s.desc_gu ? s.desc_gu : s.desc_en}</p>
            <div className="mt-3">
              <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">{t("required_info")}</p>
              <ul className="text-xs text-muted-foreground mt-1 space-y-0.5">
                {(s.required_info || []).map((r) => <li key={r}>• {r}</li>)}
              </ul>
            </div>
            <div className="flex items-center justify-between mt-4 pt-3 border-t border-border">
              <div>
                <div className="font-bold text-lg text-primary">₹{s.price}</div>
                <div className="text-xs text-muted-foreground flex items-center gap-1"><Clock size={12} /> {s.eta}</div>
              </div>
              <Button className="bg-secondary hover:bg-secondary/90" onClick={() => navigate(`/order/new/${s.slug}`)} data-testid={`services-request-${s.slug}`}>
                {t("request_now")}
              </Button>
            </div>
          </div>
        ))}
      </div>
      <p className="text-xs text-muted-foreground mt-8 max-w-3xl">{t("disclaimer_text")}</p>
    </div>
  );
}
